import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"


export default class Contrato extends Base {
             
    constructor(props) {
        super(props);
        //Stimulsoft.Base.StiLicense.Key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7plofUOqPB1a4HBIXJB621mau2oiAIj+ysU7gKUXfjn/D5BocmduNB+ZMiDGPxFrAp3PoD0nYNkkWh8r7gBZ1v/JZSXGE3bQDrCQCNSy6mgby+iFAMV8/PuZ1z77U+Xz3fkpbm6MYQXYp3cQooLGLUti7k1TFWrnawT0iEEDJ2iRcU9wLqn2g9UiWesEZtKwI/UmEI2T7nv5NbgV+CHguu6QU4WWzFpIgW+3LUnKCT/vCDY+ymzgycw9A9+HFSzARiPzgOaAuQYrFDpzhXV+ZeX31AxWlnzjDWqpfluygSNPtGul5gyNt2CEoJD1Yom0VN9fvRonYsMsimkFFx2AwyVpPcs+JfVBtpPbTcZscnzUdmiIvxv8Gcin6sNSibM6in/uUKFt3bVgW/XeMYa7MLGF53kvBSwi78poUDigA2n12SmghLR0AHxyEDIgZGOTbNI33GWu7ZsPBeUdGu55R8w=";
		//this.viewer = new Stimulsoft.Viewer.StiViewer(undefined, 'StiViewer', false);
   
  //      this.report = new Stimulsoft.Report.StiReport();
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }



    async componentDidMount() {
        this.httpPost("api/v1/contrato/get", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });



        //const response = await fetch('/reports/stuffs.mrt');
        ////const data = await response.json();
        
        ////this.report.loadDocument(data);
        //this.viewer.report = this.report;

        //this.viewer.renderHtml('report');



    }
    setBodyValue(id, field, value) {

        for (var j = 0; j < this.state.data.record.contratoInfoDtos.length; j++) {
            if (this.state.data.record.contratoInfoDtos[j].id === id) {
                this.state.data.record.contratoInfoDtos[j][field] = value;
            }

        }
        this.setState({ data: this.state.data });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/contrato/save", {
            id: this.getCurrentFormId(),
            contratoType: this.state.data.record.contratoType,
            //baseWages: this.state.data.record.baseWages,
            //rightHousing: this.state.data.record.rightHousing,
            //rightChildren: this.state.data.record.rightChildren,
            //baseYears: this.state.data.record.baseYears,
            //costHelp: this.state.data.record.costHelp,
            //rightTransportation: this.state.data.record.rightTransportation,
            //rightFood: this.state.data.record.rightFood,
            //rightAttraction: this.state.data.record.rightAttraction,
            //rightMarriage: this.state.data.record.rightMarriage,
            contratoDateStr: this.state.data.record.contratoDateStr,
            dateStartStr: this.state.data.record.dateStartStr,
            dateEndStr: this.state.data.record.dateEndStr,
            description: this.state.data.record.description,
            isActive: this.state.data.record.isActive,
            contratoInfos: this.state.data.record.contratoInfoDtos

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/contratos/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    changeType(type) {
        this.state.data.record.contratoType = type;
        this.setState({ data: this.state.data });
    }
    handleChange(value) {
        //تغییرات روی تاریخ رو اینجا اعمال کنید
        this.state.data.record.dateStart = value;
        this.setState(this.state.data.record.dateStart = value);
    }
    setContratoDateStr(v) {
        let data = v.toString();
        this.state.data.record.contratoDateStr = data;
        this.setState({ data: this.state.data });
    }

    setDateStartStr(v) {
        let data = v.toString();
        this.state.data.record.dateStartStr = data;
        this.setState({ data: this.state.data });
    }
    setDateEndStr(v) {
        let data = v.toString();
        this.state.data.record.dateEndStr = data;
        this.setState({ data: this.state.data });
    }

    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <span>قرارداد جناب آقا/خانم:{this.state.data.record.personName}</span>
                                    </div>

                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="base">
                                                <div className="row g-4">
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">نوع قرارداد</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" defaultValue={this.state.data.record.contratoType} onChange={e => this.changeType(parseInt(e.target.value))}>
                                                                    <option value="0">انتخاب نوع قرارداد</option>
                                                                    <option value="1">قراردادی</option>
                                                                    <option value="2">شرکتی</option>
                                                                    <option value="3">رسمی</option>
                                                                    <option value="4">پیمانی</option>
                                                                    <option value="5">مامور</option>
                                                                    <option value="6">کارمزدی</option>
                                                                    <option value="7">خرید خدمت</option>
                                                                    <option value="8">ساعتی</option>
                                                                    <option value="9">روزمزد</option>
                                                                    <option value="10">رسمی-آزمایشی</option>
                                                                    <option value="11">رسمی فصلی</option>
                                                                    <option value="12">سایر</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                       
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ شروع همکاری</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.dateStartStr}

                                                                    style={{

                                                                        height: "34px",

                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setDateStartStr(e)}
                                                                    mobileLabels={{
                                                                        OK: "Accept",
                                                                        CANCEL: "Close",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                                {/*<input className="form-control"  type="text" defaultValue={this.state.data.record.dateStart} onChange={e => this.state.data.record.dateStart = e.target.value} />*/}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ پایان همکاری</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.dateEndStr}

                                                                    style={{

                                                                        height: "34px",

                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setDateEndStr(e)}
                                                                    mobileLabels={{
                                                                        OK: "Accept",
                                                                        CANCEL: "Close",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                                {/*<input className="form-control"  type="text" defaultValue={this.state.data.record.dateStart} onChange={e => this.state.data.record.dateStart = e.target.value} />*/}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">تاریخ قرارداد</label>
                                                            <div className="form-control-wrap">
                                                                <DatePicker className="rmdp-mobile"
                                                                    value={this.state.data.record.contratoDateStr}

                                                                    style={{

                                                                        height: "34px",

                                                                        fontSize: "14px",
                                                                        padding: "3px 10px"
                                                                    }}
                                                                    onChange={e => this.setContratoDateStr(e)}
                                                                    mobileLabels={{
                                                                        OK: "Accept",
                                                                        CANCEL: "Close",
                                                                    }} calendar={persian}
                                                                    locale={persian_fa} />
                                                                {/*<input className="form-control"  type="text" defaultValue={this.state.data.record.dateStart} onChange={e => this.state.data.record.dateStart = e.target.value} />*/}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.data.record.contratoInfoDtos.map((record, index) =>
                                                        <div className="col-lg-2">
                                                            <div className="form-group">
                                                                <label className="form-label">{record.title}</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control" type="text" defaultValue={record.stringValue} onChange={e => this.setBodyValue(record.id, 'stringValue', e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )}
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">توضیحات</label>
                                                            <div className="form-control-wrap">
                                                                <textarea className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isActive} onChange={e => this.state.data.record.isActive = e.target.checked} id="customSwitch2" />
                                                                <label className="custom-control-label" htmlFor="customSwitch2"> قراداد فعال </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ثبت</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}